import Vue from 'vue'

import * as TYPES from './types'

export default {
  [TYPES.SET_CONTENT_SYNCED_DATE](state, { date }) {
    Vue.set(state, 'lastSyncDate', date)
  },
  [TYPES.SET_CONTENT_SYNCED](state, { sync }) {
    Vue.set(state, 'contentSync', sync)
  }
}
